import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

declare const window: any;

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
})
export class ModalComponent implements OnInit, AfterViewInit {
  @ViewChild('modal', { static: false })
  private modalRef?: ElementRef<HTMLDivElement>;
  private modalInstance: any | null = null;

  @Input() modalId: string = 'my-modal';
  @Input() title: string = 'Modal Title';
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' = 'md';
  @Input() isCentered: boolean = true;
  @Input() isScrollable: boolean = true;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (typeof window !== 'undefined' && window?.bootstrap) {
      if (this.modalRef?.nativeElement) {
        this.modalInstance = new window.bootstrap.Modal(this.modalRef.nativeElement);
      }
    }
  }

  close(): void {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }

  open(): void {
    if (this.modalInstance) {
      this.modalInstance.show();
    }
  }
}
